import { render, staticRenderFns } from "./InfoSingle.vue?vue&type=template&id=0e79d980&scoped=true&"
import script from "./InfoSingle.vue?vue&type=script&lang=js&"
export * from "./InfoSingle.vue?vue&type=script&lang=js&"
import style0 from "./InfoSingle.vue?vue&type=style&index=0&id=0e79d980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e79d980",
  null
  
)

export default component.exports